<template>
  <div>
    <div class="container">
      <!-- <section class="section">
        <HeadingLv3 id="result" text="これまでの成績" band class="heading" />
      </section> -->

      <section class="section">
        <HeadingLv3
          id="backnumber"
          text="バックナンバー"
          band
          class="heading"
        />
        <div class="list-container">
          <ExamMasterList @input="setCategory" module :ignoreId="ignoreId" />
          <Button
            label="バックナンバー一覧"
            primary
            :handleClick="
              () => {
                $router.push(`/magazines/exam/master/list/${state.category}`)
              }
            "
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import ExamMasterList from '@/components/block/ExamMasterList.vue'
import { reactive, defineComponent } from 'vue'

export default defineComponent({
  name: 'MasterFooter',
  props: {
    ignoreId: Number
  },
  components: {
    HeadingLv3,
    ExamMasterList,
    Button
  },

  setup() {
    const state = reactive({
      category: '1'
    })
    const setCategory = (e: string) => {
      state.category = e
    }
    return {
      state,
      setCategory
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.section + .section {
  margin-top: 20px;
}
::v-deep(.heading .band) {
  font-weight: 300;
  font-size: 1.7rem;
  @include mixins.media() {
    margin: 0;
  }
}
.container {
  @include mixins.media() {
    border: 1px solid var.$color-border-gray;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
}
.list-container {
  > button {
    margin: 20px auto;
  }
  @include mixins.media() {
    padding: 0 16px 16px;
  }
}
</style>
